export default __webpack_public_path__ + "assets/images/352c02620b10706d299fd04abd6a54c6.svg";